import { useEffect, useState } from "react";
import axios from "axios";
import { BarChart3 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WeekOverview = ({ profile, refreshKey }) => {
  const [weeks, setWeeks] = useState([]);
  useEffect(() => {
    axios.get(`${API}/crm/stats`, { params: { profile } })
      .then(({ data }) => setWeeks([...(data.weekly || [])].reverse()))
      .catch(() => setWeeks([]));
  }, [profile, refreshKey]);
  const tot = weeks.reduce((a, w) => ({ sent: a.sent + w.sent, replies: a.replies + w.replies, customers: a.customers + (w.customers || 0) }), { sent: 0, replies: 0, customers: 0 });
  const pct = (r, s) => (s ? `${Math.round((r / s) * 100)}%` : "—");
  if (!weeks.length) return null;
  return (
    <div data-testid="week-overview" className="mb-6 rounded-lg border border-slate-200 bg-white p-4">
      <div className="flex items-center gap-2 mb-3">
        <BarChart3 className="w-4 h-4 text-[#FF4500]" strokeWidth={1.75} />
        <h3 className="font-display font-bold">Weekoverzicht</h3>
        <span className="text-xs text-slate-400">laatste 8 weken · week vanaf maandag</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs uppercase tracking-wide text-slate-400">
              <th className="py-1.5 pr-4 font-semibold">Week van</th>
              <th className="py-1.5 pr-4 font-semibold text-right">Verzonden</th>
              <th className="py-1.5 pr-4 font-semibold text-right">Reacties</th>
              <th className="py-1.5 pr-4 font-semibold text-right">Reactie-%</th>
              <th className="py-1.5 pr-4 font-semibold text-right">Klanten</th>
              <th className="py-1.5 font-semibold text-right">Conversie-%</th>
            </tr>
          </thead>
          <tbody>
            {weeks.map((w, i) => (
              <tr key={w.week} data-testid={`week-row-${i}`} className={`border-t border-slate-100 ${i === 0 ? "font-semibold" : ""}`}>
                <td className="py-1.5 pr-4">{w.week}{i === 0 && <span className="ml-2 text-xs font-normal text-[#FF4500]">deze week</span>}</td>
                <td className="py-1.5 pr-4 text-right tabular-nums">{w.sent}</td>
                <td className="py-1.5 pr-4 text-right tabular-nums">{w.replies}</td>
                <td className="py-1.5 pr-4 text-right tabular-nums">{pct(w.replies, w.sent)}</td>
                <td className="py-1.5 pr-4 text-right tabular-nums">{w.customers || 0}</td>
                <td className="py-1.5 text-right tabular-nums">{pct(w.customers || 0, w.sent)}</td>
              </tr>
            ))}
            <tr data-testid="week-total" className="border-t-2 border-slate-200 font-bold">
              <td className="py-1.5 pr-4">Totaal</td>
              <td className="py-1.5 pr-4 text-right tabular-nums">{tot.sent}</td>
              <td className="py-1.5 pr-4 text-right tabular-nums">{tot.replies}</td>
              <td className="py-1.5 pr-4 text-right tabular-nums">{pct(tot.replies, tot.sent)}</td>
              <td className="py-1.5 pr-4 text-right tabular-nums text-amber-600">{tot.customers}</td>
              <td className="py-1.5 text-right tabular-nums">{pct(tot.customers, tot.sent)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
